import { BASE_URL, STORAGE_SUF } from "../constants"
import { fetchWithAuth } from "../utils/fetchWithAuth"

const suffix = localStorage.getItem(STORAGE_SUF) || ""

export const clearCache = async (
  loginData: {
    knSkData: string
    knSkIv: string
    ftnSkData: string
    ftnSkIv: string
    knCzData: string
    knCzIv: string
    ftnCzData: string
    ftnCzIv: string
  },
  portals: {
    knSk: boolean
    ftnSk: boolean
    knCz: boolean
    ftnCz: boolean
  },
  onPartialUpdate: (message: string) => void,
): Promise<void> => {
  try {
    const response = await fetchWithAuth(
      `${BASE_URL}/clear-cache-${suffix}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ loginData, portals }),
      },
    )

    if (!response.ok) {
      throw new Error(`Failed to clear cache: ${response.status}`)
    }

    const reader = response.body?.getReader()
    if (!reader) {
      throw new Error("ReadableStream not supported in this browser.")
    }

    const decoder = new TextDecoder()
    let buffer = ""

    // Read from the stream until done
    while (true) {
      const { done, value } = await reader.read()
      if (done) break
      // Decode the chunk and add it to the buffer
      buffer += decoder.decode(value, { stream: true })
      // Split based on newlines (or your chosen delimiter)
      const parts = buffer.split("\n")
      // Keep the last part if it's incomplete
      buffer = parts.pop() || ""
      // Process complete parts
      parts.forEach((part) => {
        if (part.trim()) {
          onPartialUpdate(part.trim())
        }
      })
    }
  } catch (error) {
    console.error("Request failed", error)
    throw error
  }
}
